/**
 * Hospital Search Modal Component
 *
 * Full hospital master list (parity with HospitalPage) for picking a hospital in forms.
 */

import React from 'react';
import { AppModal } from '@/components/atoms';
import type { Hospital } from '@/pages/main/hospital/types';
import HospitalMasterListPanel from '@/pages/main/hospital/HospitalMasterListPanel';
interface HospitalSearchModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (hospital: Hospital) => void;
  onDelete?: (hospital: Hospital) => void;
  /** Pre-filled search keyword (usually hospital name) */
  initialHospitalName?: string;
}

const HospitalSearchModal: React.FC<HospitalSearchModalProps> = ({
  isOpen,
  onClose,
  onSelect,
  onDelete,
  initialHospitalName = '',
}) => {
  return (
    <AppModal title="医療機関検索" isOpen={isOpen} onClose={onClose} maxWidth="max-w-6xl">
      <div className="relative min-h-[320px]">
        {isOpen ? (
          <HospitalMasterListPanel
            variant="modal"
            isActive={isOpen}
            initialHospitalName={initialHospitalName}
            onPickHospital={h => {
              onSelect(h);
              onClose();
            }}
            onDeleteHospital={onDelete}
          />
        ) : null}
      </div>
    </AppModal>
  );
};

export default HospitalSearchModal;
